{
  "response_error_title": "Det har skjedd en teknisk feil",
  "response_error_description": "Prøv igjen senere.",
  "loggoverbruk_ikke_tilgjengelig": "Innsyn i logg er foreløpig ikke tilgjengelig digitalt. Ta kontakt med dataansvarlig for utlevering av informasjon.",
  "fanetittel_postfiks": "- Innsyn i register - Helsenorge",
  "innhold_tab": "Innhold",
  "loggoverbruk_tab": "Logg over bruk",
  "logg_over_utleveringer_tab": "Logg over utleveringer",
  "ugyldig_register": "Registeret finnes ikke.",
  "page_helseregistre_navigatebacklinktitle": "til Helseregistre"
}
